module.exports = __webpack_public_path__ + "img/svg/daily.4e0ae2fb2f3ce0083286d53f4ec1a76d.svg";